import banner from "../../../courses/module-2/img4.png";

const modulo4 = {
  courseId: "cripto-blockchain",
  id: "modulo-4",
  title: "🧩 MÓDULO 4: Stablecoins, Tokens y el Mundo Real del Cripto",
  estimatedDuration: "1 hora",
  format: "Lectura + actividad de verificación",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 ¿Qué aprenderás en este módulo?",
      content: [
        "Qué es una stablecoin y por qué son clave en el ecosistema Web3.",
        "En qué se diferencian tokens y monedas nativas.",
        "El rol real de USDT, USDC, DAI y XLM.",
        "Ejemplos reales de uso en trading, pagos, remesas y ahorro.",
        "Cómo evitar errores comunes al transferir entre redes diferentes.",
      ],
    },
    {
      id: "conceptos-clave",
      navLabel: "Conceptos clave",
      title: "📚 Conceptos clave",
      content: [
        {
          type: "paragraph",
          text: "🟡 ¿Qué es una stablecoin?",
        },
        {
          type: "paragraph",
          text: "Una stablecoin es una criptomoneda diseñada para tener un valor estable. Su precio está normalmente “atado” a una moneda tradicional (como el dólar o el euro). Se usan como puente entre el mundo cripto y el dinero tradicional.",
        },
        {
          type: "paragraph",
          text: "Ejemplos populares:",
        },
        {
          type: "list",
          items: [
            "USDT (Tether): La más usada, pero ha recibido críticas por su falta de transparencia.",
            "USDC (USD Coin): Emitida por Circle y respaldada 100% por dólares en reserva.",
            "DAI: Stablecoin descentralizada creada por el protocolo MakerDAO. No depende de bancos, sino de colateral en otras criptos.",
          ],
        },
        {
          type: "paragraph",
          text: "🧾 ¿Qué es un token?",
        },
        {
          type: "paragraph",
          text: "Un token es un activo digital construido sobre una blockchain existente. Por ejemplo, USDT es un token que puede existir en la red Ethereum, en la red Tron, en Polygon, etc.",
        },
        {
          type: "paragraph",
          text: "🔗 ¿Y qué es una moneda nativa?",
        },
        {
          type: "paragraph",
          text: "Es la criptomoneda que pertenece de forma nativa a una red blockchain. Por ejemplo:",
        },
        {
          type: "list",
          items: [
            "BTC es la moneda nativa de Bitcoin.",
            "ETH es la moneda nativa de Ethereum.",
            "XLM es la moneda nativa de Stellar.",
          ],
        },
        {
          type: "paragraph",
          text: "Estas monedas suelen ser necesarias para pagar comisiones (conocidas como fees o gas) dentro de sus respectivas redes.",
        },
      ],
    },
    {
      id: "nota",
      navLabel: "Nota Importante",
      title: "⚠️ NOTA IMPORTANTE – No confundas la red con la criptomoneda",
      content: [
        {
          type: "paragraph",
          text: "A veces, una misma criptomoneda (como USDT o USDC) puede existir en diferentes redes: Ethereum, Polygon, Solana, etc.",
        },
        {
          type: "paragraph",
          text: "Si la envías por la red equivocada, puedes perderla para siempre.",
        },
        {
          type: "paragraph",
          text: "✅ Siempre verifica:",
        },
        {
          type: "list",
          items: [
            "La red correcta antes de enviar o recibir.",
            "Que la otra persona o plataforma acepte esa red.",
            "Que el token sea compatible con la red elegida.",
          ],
        },
        {
          type: "paragraph",
          text: "🧠 En Web3, tú eres el único responsable de tus fondos. Nunca hagas transferencias sin estar 100% seguro.",
        },
      ],
    },
    {
      id: "ejemplos-reales",
      navLabel: "Ejemplos",
      title: "🌐 Ejemplos del mundo real",
      content: [
        {
          type: "list",
          items: [
            "USDC sobre Stellar: usado por ONG’s para distribuir ayuda humanitaria en zonas de conflicto, con bajo costo y sin necesidad de bancos.",
            "USDT en Binance y KuCoin: utilizado como moneda base para comprar y vender otras criptos.",
            "DAI en DeFi: sirve para obtener préstamos y generar intereses sin pasar por bancos.",
            "XLM en MoneyGram: usado para remesas rápidas y baratas en América Latina.",
          ],
        },
      ],
    },
    {
      id: "recursos",
      navLabel: "Recursos",
      title: "📌 Recursos recomendados",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/what-is-a-stablecoin",
          text: "Binance Academy – ¿Qué es una stablecoin?",
        },
        {
          type: "link",
          href: "https://www.coinbase.com/es-ar/usdc",
          text: "Coinbase Learn – ¿Qué es USDC?",
        },
        {
          type: "link",
          href: "https://academy.binance.com/en/glossary/coin",
          text: "Binance Academy – Tokens vs Coins",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Actividad",
      title: "📝 Actividad: tabla comparativa + reflexión",
      content: [
        {
          type: "paragraph",
          text: "🔧 Instrucciones paso a paso",
        },
        {
          type: "orderedList",
          items: [
            "Entra a docs.google.com y crea un nuevo documento.",
            "Inserta una tabla de 6 columnas y 5 filas.",
            "Copia el modelo de abajo y complétalo con la información aprendida:",
          ],
        },
        {
          type: "table",
          headers: [
            "Nombre",
            "Tipo (moneda o stablecoin)",
            "¿Quién la emite?",
            "¿Red principal?",
            "¿Para qué se usa?",
            "Nivel de riesgo",
          ],
          rows: [
            ["USDT", "", "", "", "", ""],
            ["USDC", "", "", "", "", ""],
            ["DAI", "", "", "", "", ""],
            ["XLM", "", "", "", "", ""],
          ],
        },
        {
          type: "paragraph",
          text: "4. Agrega una conclusión:",
        },
        {
          type: "paragraph",
          text: "¿Cuál te parece más útil o segura como principiante? ¿Por qué?",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase",
      title: "🧠 Frase del día",
      content: [
        "“Entender el valor real de una moneda es más importante que saber cuánto cuesta.”",
      ],
    },
  ],
};

export default modulo4;
